import { useManagePopularItem } from "@features/popular/use-manage-popular-item";
import { Button, TextField, Flex, Text, Switch } from "@radix-ui/themes";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ResponsiveModal } from "@components/responsive-modal";

export const PopularManagementModal = () => {
  const { t } = useTranslation();
  const { isOpen, closeModal } = useManagePopularItem();
  return (
    <ResponsiveModal
      isOpen={isOpen}
      onClose={closeModal}
      title={t("components.popular.management.title")}
      height="auto"
      maxHeight="90vh"
    >
      {isOpen && <PopularManagementModalContent />}
    </ResponsiveModal>
  );
};

export const PopularManagementModalContent = () => {
  const {
    closeModal,
    currentItem: item,
    addPopular,
    removePopular,
    isAddingPopular,
    isRemovingPopular,
  } = useManagePopularItem();
  const { t } = useTranslation();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [isPublic, setIsPublic] = useState(false);

  // Initialize form when item changes
  useEffect(() => {
    if (item) {
      setName(item.name || "");
      setDescription(item.description || "");
      setIsPublic(item.popularity ? item.popularity > 0 : false);
    }
  }, [item]);

  const handleSave = () => {
    if (!item) return;

    if (isPublic) {
      addPopular({ item, name, description });
    } else {
      removePopular(item);
    }
  };

  const isLoading = isAddingPopular || isRemovingPopular;

  return (
    <Flex direction="column" gap="4">
      <Flex direction="row" gap="4">
        <Flex direction="column" gap="4" className="grow">
          <Flex direction="column" gap="2">
            <Text as="label" size="2" weight="bold">
              {t("components.popular.management.make_public")}
            </Text>
            <Switch checked={isPublic} onCheckedChange={setIsPublic} />
          </Flex>

          {isPublic && (
            <>
              <Flex direction="column" gap="2">
                <Text as="label" htmlFor="name" size="2" weight="bold">
                  {t("components.popular.management.name")}
                </Text>
                <TextField.Root
                  id="name"
                  placeholder={t("components.popular.management.enter_name")}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Flex>

              <Flex direction="column" gap="2">
                <Text as="label" htmlFor="description" size="2" weight="bold">
                  {t("components.popular.management.description")}
                </Text>
                <TextField.Root
                  id="description"
                  placeholder={t(
                    "components.popular.management.enter_description"
                  )}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Flex>
            </>
          )}
        </Flex>
        <div className="shrink-0">
          <img src={item?.url} className="h-64 rounded-md" alt={item?.name} />
        </div>
      </Flex>

      <Flex gap="3" mt="4" justify="end">
        <Button variant="soft" color="gray" onClick={closeModal}>
          {t("components.popular.management.cancel")}
        </Button>
        <Button onClick={handleSave} disabled={isLoading}>
          {isLoading
            ? t("components.popular.management.saving")
            : t("components.popular.management.save")}
        </Button>
      </Flex>
    </Flex>
  );
};
